import { Component } from '@angular/core';

@Component({
  selector: 'app-shipping-delivery',
  imports: [],
  templateUrl: './shipping-delivery.component.html',
  styleUrl: './shipping-delivery.component.scss'
})
export class ShippingDeliveryComponent {

}
